<template lang="pug">
.input.input--select(:class="{'input--secondary': secondary}")
  label(
    v-if="label", 
    :for="'select' + _uid"
    id="deliverEveryLabel"
  ) {{ label }}
  v-select(
    @keydown.space.prevent.stop="toggleDropdown"
    ref="vSelect"
    v-if="!showNativeSelect"
    :options="optionSet"
    :disabled="$attrs.disabled"
    :clearable="false"
    :value="selectedValue"
    :placeholder="defaultOption"
    :searchable="false"
    :select-on-tab="true"
    @input="update"
    :id="'select' + _uid"
    :aria-labelledby="`deliverEveryLabel`"
  )
    template(
      #open-indicator="{ attributes }"
    )
      span(
        v-bind="attributes"
        @keydown.space.prevent.stop="(event) => $refs.vSelect.toggleDropdown"
        :menu-open-on-focus="true"
      )
        icon(
          name="chevron-down"
          size="22px"
        ) 
  template(v-else)
    select(v-model="currentValue", :disabled="$attrs.disabled", :id="'select' + _uid")
      option(value="" disabled selected) Select an Option
      option(v-for="option in options", :value="option.value", :key="option.value") {{ option.label }}
    .icon--default-select
      icon(
        name="chevron-down"
        size="22px"
      ) 
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue'
import TextInput from 'scripts/components/forms/TextInput.vue'
import vSelect from 'vue-select'

  export default {
    name: 'SelectInput',
    extends: TextInput,
    components: { vSelect, Icon },
    props: {
      options: {
        type: Array
      },
      label: {
        type: String
      },
      selected: {
        type: [String, Number],
        default: ''
      },
      hideLabel: {
        type: Boolean,
        default: false
      },
      // only shows when not required
      placeholder: {
        type: String,
        default: 'Select an Option'
      },
      disableDefault: {
        type: Boolean
      },
      iconSize: {
        type: String,
        default: '10px'
      },
      secondary: {
        type: Boolean,
        default: false
      },
      icon: String,
      value: [String, Number, Object],
    },
    computed: {
      defaultOption () {
        return (this.placeholder !== '') ? this.placeholder : ''
      },
      optionSet () {
        if (this.disableDefault === true) {
          return this.options
        } else {
          return this.$attrs.required ? this.options : [{ label: this.defaultOption, value: 'default' }, ...this.options]
        }
      },
      selectedValue () {
        return this.options.find(option => option.value === this.currentValue)
      },
      showNativeSelect () {
        return this.$mq === 'mobile'
      },
      labelClass () {
        return {
          'u-sr-only': this.hideLabel
        }
      },
      iconName() {
        if (this.icon) {
          return this.icon;
        }
        return 'chevron-down';
      }
    },
    created () {
      if (this.$attrs.required && this.currentValue === '' && this.options.length > 0) {
        this.currentValue = this.value ? this.value : this.options[0].value
        this.$emit('input', this.currentValue)
      }

      if ( this.selected !== '' ) {
        let selected = { value: this.selected }
        this.update(selected)
      }
    },
    watch: {
      value() {
        this.currentValue = this.value.id || this.value;
      },
      currentValue() {
        this.$emit('input', this.currentValue)
      }
    },
    methods: {
      update(val) {
        this.currentValue = val.value
      },
      selectVueSelect (event) {
        this.$refs.vSelect.toggleDropdown(event);
      },
      toggleDropdown(event) {
        event.stopPropagation();
        this.$refs.vSelect.isMenuActive = !this.$refs.vSelect.isMenuActive;
      }
    }
  }
</script>

<style scoped lang="scss">
  .input {
    margin-bottom: 0px;
  }

  .icon--default-select {
    position: absolute;
    top: 5px;
    right: 5px;
  }
</style>